import PouchDB from "pouchdb-browser";
import WebSQLPouch from "pouchdb-adapter-websql";
import UpsertPouch from "pouchdb-upsert";
import { pathOr, pathSatisfies, propEq } from "ramda";
import { PRESENTATION_MODE } from "~/constants/presentation-modes";
import { REHYDRATE } from "redux-persist";

import { addAllMaterials as addAllDlsMaterials } from "~/store/ducks/application/materials/dlsMaterials";

import { addAllMaterials as addAllPoolMaterials } from "~/store/ducks/application/materials/materialPool";

PouchDB.plugin(WebSQLPouch).plugin(UpsertPouch);

const baseUrl = new URL(window.location.href);
const materialUrl = new URL("store/material", baseUrl);
const userUrl = new URL("store/user", baseUrl);
const fileUrl = new URL("store/file", baseUrl);
const poolUrl = new URL("store/materialpool", baseUrl);

const options = {
  live: true,
  retry: true,
  timeout: false,
  heartbeat: false
};

const localMaterialDB = new PouchDB(`material_${baseUrl.pathname}`, {
  revs_limit: 25
});
const localUserDB = new PouchDB(`user_${baseUrl.pathname}`, { revs_limit: 25 });
const localPoolDB = new PouchDB(`pool_${baseUrl.pathname}`, { revs_limit: 25 });

const remoteMaterialDB = new PouchDB(materialUrl.href);
const remoteUserDB = new PouchDB(userUrl.href);
const remoteFileDB = new PouchDB(fileUrl.href);
const remotePoolDB = new PouchDB(poolUrl.href);

const repliacteMaterials = () =>
  localMaterialDB.replicate.from(remoteMaterialDB);
const repliacteUser = () => localUserDB.replicate.from(remoteUserDB);
const replicatePool = () => localPoolDB.replicate.from(remotePoolDB);

const replicateDlsMaterials = store =>
  remoteMaterialDB.replicate
    .to(localMaterialDB)
    .then(() => localMaterialDB.allDocs({ include_docs: true }))
    .then(result => result.rows)
    .then(rows => rows.map(row => row.doc))
    .then(docs => docs.filter(doc => doc.type === "dlsmaterial"))
    .then(docs => store.dispatch(addAllDlsMaterials(docs)));

const replicateMaterialPool = store =>
  fetch(poolUrl.href)
    .then(response => response.json())
    .then(body => body.docs)
    .then(docs => store.dispatch(addAllPoolMaterials(docs)));

const replicateUiState = store =>
  remoteUserDB.replicate
    .to(localUserDB, {
      doc_ids: ["uistate"]
    })
    .then(() => localUserDB.get("uistate"))
    .then(doc => doc.state)
    .then(state => {
      const isDls = pathOr(
        false,
        ["features", "dls"],
        window.getClientConfiguration()
      );
      const hasMode = pathSatisfies(x => x !== "", ["displayMode"], state);

      if (isDls && !hasMode) {
        return {
          ...state,
          displayMode: PRESENTATION_MODE
        };
      }

      return state;
    })
    .then(payload =>
      store.dispatch({ type: REHYDRATE, payload, key: "uistate" })
    )
    .then(() => console.log("Hydration completed"))
    .catch(err => {
      console.error("Hydration failed");
      console.error(err);
    });

const destroyDbFactory = db => reload =>
  db
    .destroy()
    .then(() => {
      console.info("material db was destroyed.");

      if (reload) {
        console.info("reloading page...");
        window.location.reload();
      }
    })
    .catch(error => console.error(error));

window.destroyMaterialDB = destroyDbFactory(localMaterialDB);
window.destroyUserDB = destroyDbFactory(localUserDB);

// // localMaterialDB.replicate
// //   .to(remoteMaterialDB, {
// //     live: true,
// //     retry: true,
// //     timeout: false,
// //     heartbeat: false,
// //     filter(doc) {
// //       return doc.type === "material" || doc._deleted;
// //     }
// //   })
// //   .on("cancel", console.log)
// //   .on("error", console.error)
// //   .on("completed", console.log)
// //   .on("complete", console.log)
// //   .on("denied", console.error);
// // })
// // .catch(err => {
// //   console.error(err);
// //   if (err.name === "indexed_db_went_bad") {
// //     indexedDbNotAccessible = true;
// //   }
// // });

// localMaterialDB
//   .sync(remoteMaterialDB, { live: true })
//   .on("change", change => console.log("change", change))
//   .on("paused", info => console.log("paused", info))
//   .on("active", info => console.log("active", info))
//   .on("error", error => console.error("error", error));

// if (window.getClientConfiguration(false, ["book", "drm"])) {
localUserDB.replicate.from(remoteUserDB).then(result => {
  // console.log("replicate result", result);
  //     // localUserDB
  //     //   .changes({ since: "now", live: true })
  //     //   .on("change", change => console.log("change", change))
  //     //   .on("paused", info => console.log("paused", info))
  //     //   .on("active", info => console.log("active", info))
  //     //   .on("error", error => console.error("error", error));

  localUserDB.sync(remoteUserDB, {
    live: true,
    retry: true,
    filter: propEq("_id", "uistate")
  });
  // .on("change", change => console.log("change", change))
  // .on("paused", info => console.log("paused", info))
  // .on("active", info => console.log("active", info))
  // .on("error", error => console.error("error", error));
});
// }

export {
  baseUrl,
  options,
  localMaterialDB,
  remoteMaterialDB,
  localUserDB,
  remoteUserDB,
  remoteFileDB,
  fileUrl,
  remotePoolDB,
  localPoolDB,
  repliacteMaterials,
  repliacteUser,
  replicatePool,
  replicateUiState,
  replicateDlsMaterials,
  replicateMaterialPool
};
